import React, { useState, useEffect, useRef } from "react";
// import { useParams, Link } from "react-router-dom";
// import { Accordion } from 'react-bootstrap';

import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";

import Modalgallery from "../../../components/modalReflec";

import Header from "../../../layout/header";
import Footer from "../../../layout/footer";
import { Link } from "react-router-dom";
import moment from "moment";
import LinesEllipsis from "react-lines-ellipsis";
// import banner from "../../../assets/img/banner-wasteHero.png";
import img001 from "../../../assets/img/impact/banner.jpg";
import nimgBanner from './../../../assets/img/impact/banner2.jpg';
// import img002 from "../../../assets/img/hero_02.jpg";
import sorn from "../../../assets/img/icon/ss.png";
import img01 from "../../../assets/img/20-01-2568/1_0.jpg";
import img02 from "../../../assets/img/20-01-2568/2_0.jpg";
import img03 from "../../../assets/img/20-01-2568/3_0.jpg";
import img04 from "../../../assets/img/20-01-2568/4_0.jpg";
import img05 from "../../../assets/img/20-01-2568/5_0.jpg";
import img06 from "../../../assets/img/20-01-2568/6_0.jpg";
import img07 from "../../../assets/img/20-01-2568/7_0.jpg";
import img08 from "../../../assets/img/20-01-2568/8_0.jpg";
import img09 from "../../../assets/img/20-01-2568/9_0.jpg";
import img10 from "../../../assets/img/20-01-2568/10_0.jpg";
import img11 from "../../../assets/img/20-01-2568/11_0.jpg";
import img12 from "../../../assets/img/20-01-2568/12_0.jpg";
import img13 from "../../../assets/img/20-01-2568/13_0.jpg";
import img14 from "../../../assets/img/20-01-2568/14_0.jpg";
import img15 from "../../../assets/img/20-01-2568/15_0.jpg";
// import img02 from "../../../assets/img/hero_2.jpg";
// import img03 from "../../../assets/img/hero_3.jpg";
// import vector1 from "../../../assets/img/icon/vector_1.svg";
// import vector2 from "../../../assets/img/icon/vector_2.svg";
// import vector3 from "../../../assets/img/icon/vector_3.svg";
// import vector4 from "../../../assets/img/icon/vector_4.svg";
// import vector5 from "../../../assets/img/icon/vector_5.svg";
// import vector6 from "../../../assets/img/icon/Malaysia.svg";

import nimg5 from './../../../assets/img/02-2025/5_0.png';
import nimg6 from './../../../assets/img/02-2025/6_0.png';
import nimg8 from './../../../assets/img/02-2025/8_0.png';
import nimg9 from './../../../assets/img/03-2025/9_0.png';
import nimg10 from './../../../assets/img/02-2025/7_0.png';
import nimg11 from './../../../assets/img/03-2025/11_0.png';

import nitems1 from './../../../assets/img/impact/item1.png';
import nitems2 from './../../../assets/img/impact/item2.png';

import pitems1 from './../../../assets/img/impact/3_0.png';
import pitems2 from './../../../assets/img/impact/4_0.png';
import pitems3 from './../../../assets/img/impact/5_0.png';
import pitems4 from './../../../assets/img/impact/6_0.png';
import pitems5 from './../../../assets/img/impact/7_0.png';
import pcontent from './../../../assets/img/impact/pcontent.png';
import pfooter from './../../../assets/img/impact/pfooter.png';

import nsornUp from './../../../assets/img/icon/sorn-up.svg';

import Loading from "../../../components/loading";
import { getData } from "../../../services/getService";

const ggal = [{ src: img01 }, { src: img02 }, { src: img03 }, { src: img04 }, { src: img05 }, { src: img06 }, { src: img07 }, { src: img08 }, { src: img09 }, { src: img10 }, { src: img11 }, { src: img12 }, { src: img13 }, { src: img14 }, { src: img15 }]

const Main = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [dataOne, setDataOne] = useState({});
    const [dataS, setDataS] = useState(null);
    const [dataLimit, setDataLimit] = useState(3);

    const [mainData, setMainData] = useState(ggal);
    const [modalgallery, setModalgallery] = useState({ view: false });

    const called = useRef(true);

    useEffect(() => {
        if (called.current) {
            Promise.all([fetchDataOne()]).then(
                (res) => {
                    setIsLoading(false);
                }
            );
        }
        return () => {
            called.current = false;
        };
    }, []);

    const fetchDataOne = async () => {
        getData("pageawards", "impact")
            .then((response) => {
                if (response.status === "success") {
                    setDataOne(response.data)
                }
            })
            .catch((e) => {
                console.log(e.response.data.error);
            });
    };

    const responsive = {
        0: { items: 1 },
        568: { items: 2 },
        1024: { items: 3 },
    };
// 
    console.log(dataOne)

    return (
        <>
            <div id="outer-container" style={{}}>
                <Header page="activities" sub="partnership" />
                <div className="wrapper bg-white box-index">
                    {/* {isLoading ? <Loading /> : null} */}
                    <section className="pb-md-5 bg-top">
                        <div className="container-fluid">
                            <div className="row justify-content-center pb-md-5 text-start">
                                <div className="col-12 col-md-12 col-lg-12 p-0">
                                    <div className="">
                                        <img src={process.env.REACT_APP_IMG_LINK + "/uploads/awards/" + dataOne.id + '/' + dataOne.img} className="w-100 rounded" alt="" />
                                    </div>
                                </div>
                                <div className="col-12 col-md-12 col-lg-9 mt-3 mt-md-4">
                                    <div className="font-50 weight-700">{dataOne.topic}</div>
                                    <div className="pt-3">
                                        <div className="font-18 text-justify content-custom"
                                            dangerouslySetInnerHTML={{
                                                __html: dataOne.detail,
                                            }}
                                        />
                                    </div>

                                </div>

                            </div>
                            <div className="row justify-content-center py-3 py-md-5 text-start" style={{ background: "#FFDE59" }}>
                                <div className="col-12 col-md-11 col-lg-9">
                                    <div>
                                        <div><img src={nimgBanner} className="w-100" /></div>
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-center pb-md-5 mt-md-5">
                                <div className="col-12 col-md-12 col-lg-9 text-justify">
                                    <div className="font-18 text-justify content-custom">
                                        <p>In 2023, SEAMEO SEPS launched the <a href="https://seameoseps.org/newsandgallery/archivesWaste/3" target="_blank">Waste Hero Development Co-campaign</a> in collaboration with Indorama Ventures PCL (IVL) and Yunus Thailand to strengthen waste management education across Southeast Asia. The initiative engaged school leaders, teachers, and students through Waste Hero Master Teacher Training, regional Waste Hero Awards, and knowledge-sharing webinars, reaching more than 5,800 educators from 11 countries and beyond. Building on this success, the <a href="https://seameoseps.org/activities/partnershipWasteHero" target="_blank">2024 Waste Hero Development Co-Campaign</a> focused on measuring the social, environmental, and sustainability impacts of school-based waste management initiatives, recognising outstanding schools as Model Schools in Waste Management and providing an international platform for sharing best practices. 5 outstanding schools from Bhutan, Indonesia, Malaysia, Philippines and Thailand were recodnized for the <a href="https://seameoseps.org/awardsGrants/seaWasteHeroAwards2024" target="_blank">2024 Waste Hero School Competition</a> award.</p>
                                        <p><br/></p><p>The 2025 Waste Hero Impact Challenge builds on these foundations as a regional initiative by SEAMEO SEPS, in collaboration with Indorama Ventures, celebrating schools that demonstrate outstanding and sustained waste management practices. Open to schools that participated in the 2024 Waste Hero School Competition, the Challenge highlights growth, innovation, and measurable environmental impact inspired by Waste Hero Education Resources. Participating schools submit a report, short video, and supporting evidence showcasing improvements in waste systems, classroom integration, and community engagement. Searching for the-Best-of-the-Best School in Waste Management, three best schools will each receive USD 500 and recognition.</p>
                                        <p><br/></p><p><a href="https://www.wasteheroeducation.com/" target="_blank">Waste Hero Education</a> is a global initiative offering free, customizable teaching resources on recycling, zero-waste, and circular economy education, with a goal to reach and educate one million young people by 2030 in Southeast Asia and beyond. </p>
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-center pb-md-5 mt-md-5">
                                <div className="col-12 col-md-12 col-lg-12 text-center">
                                    <div className="sub-topic weight-700 mt-3">About Partners</div>
                                    <div className="row justify-content-center align-items-center">
                                        <div className="col-4 col-md-2 col-lg-2 text-end">
                                            <a href="https://beta.indoramaventures.com" target={'_blank'} rel="noreferrer">
                                                <img src={nitems1} className="w-100" alt="Indorama Ventures" />
                                            </a>
                                        </div>
                                        <div className="col-4 col-md-2 col-lg-2">
                                            <a href="https://www.yunus-thailand.org" target={'_blank'} rel="noreferrer">
                                                <img src={nitems2} className="w-100" alt="Yunus Thailand" />
                                            </a>
                                        </div>
                                        {/* <div className="col-4 col-md-2 col-lg-2">
                                            <a href="https://seameoseps.org/about/whoweare" target={'_blank'}><img src={nitems3} className="w-100 p-2 p-md-4 pt-md-5" /></a>
                                        </div> */}

                                    </div>

                                </div>
                            </div>

                            <div className="row justify-content-center pb-md-5 text-start">
                                <div className="col-12 col-md-11 col-lg-9">
                                    <hr style={{ borderTop: "2px solid rgb(230, 193, 47)" }} />
                                    <div className="pt-md-5 mt-5 ">
                                        <div className="row justify-content-center text-start">

                                            <div className="col-6 col-md-3 col-lg-3">
                                                <button className="btn text-center" onClick={e => setDataS(1)}>
                                                    <img src={nimg5} className="w-75 px-4" alt="Objectives" />
                                                    <h4 className="weight-700 mt-3 h4-respon" style={{}}>Objectives</h4>
                                                </button>
                                            </div>
                                            <div className="col-6 col-md-3 col-lg-3">
                                                <button className="btn text-center" onClick={e => setDataS(2)}>
                                                    <img src={nimg6} className="w-75 px-4" alt="Participants" />
                                                    <h4 className="weight-700 mt-3 h4-respon" style={{}}>Participants</h4>
                                                </button>
                                            </div>
                                            <div className="col-6 col-md-3 col-lg-3">

                                                <button className="btn text-center" onClick={e => setDataS(3)}>
                                                    <img src={nimg10} className="w-75 px-4" alt="Activities" />
                                                    <h4 className="weight-700 mt-3 h4-respon" style={{}}>Entry Requirements</h4>
                                                </button>
                                            </div>
                                            <div className="col-6 col-md-3 col-lg-3">
                                                <a rel="noreferrer" href="https://drive.google.com/file/d/1qz_Pm6q3H_BfkY9X0J-sOldAqu619gBr/view?usp=sharing" target={"_blank"} className="btn text-center">
                                                    <img src={nimg8} className="w-75 px-4" alt="Documents" />
                                                    <h4 className="weight-700 mt-3 h4-respon" style={{}}>Documents</h4>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="d-none d-md-block">
                                            <div className="row text-start" style={{ marginBottom: "-20px" }}>
                                                <div className="col-12 col-md-3 col-lg-3 text-center">
                                                    {dataS === 1 && <img src={nsornUp} alt="" className="" style={{ width: "50px", filter: "brightness(0) saturate(100%) invert(91%) sepia(55%) saturate(6319%) hue-rotate(315deg) brightness(109%) contrast(103%)" }} />}
                                                </div>
                                                <div className="col-12 col-md-3 col-lg-3 text-center">
                                                    {dataS === 2 && <img src={nsornUp} alt="" className="" style={{ width: "50px", filter: "brightness(0) saturate(100%) invert(91%) sepia(55%) saturate(6319%) hue-rotate(315deg) brightness(109%) contrast(103%)" }} />}
                                                </div>
                                                <div className="col-12 col-md-3 col-lg-3 text-center">
                                                    {dataS === 3 && <img src={nsornUp} alt="" className="" style={{ width: "50px", filter: "brightness(0) saturate(100%) invert(91%) sepia(55%) saturate(6319%) hue-rotate(315deg) brightness(109%) contrast(103%)" }} />}
                                                </div>
                                            </div>
                                        </div>
                                        {dataS === 1 ?
                                            <div className="p-4 text-justify" style={{ background: "#FFDE59", borderRadius: "15px" }}>

                                                <div className="mb-4"><b>Objectives of the Competition</b></div>
                                                <ol type="a">
                                                    <li className="mb-4">To evaluate the continuity of Waste Hero utilisation in schools and measure the performance of waste
                                                        management system among the participating schools since 2024
                                                    </li>
                                                    <li>To identify best-performing schools, with the best evidence and results proof that reflect a program’s continuity,
                                                        measuring positive changes by showing qualitative and quantitative information that is inspired by the Waste Hero
                                                        resources.
                                                    </li>

                                                </ol>
                                            </div>
                                            : dataS === 2 ?

                                                <div className="p-4 text-justify" style={{ background: "#FFDE59", borderRadius: "15px" }}>
                                                    <div className="mb-4"><b>Who can Join</b></div>
                                                    <p>
                                                        All schools that participated in the 2024 Waste Hero School Competition are invited to join.
                                                    </p>
                                                    {/* <a href="https://drive.google.com/file/d/1THv8i7cpuSwrsjDQ5mlMl2qVzekDeAxn/view?usp=sharing" target={"_blank"}>List of Nominated Schools</a> */}
                                                </div>
                                                : dataS === 3 ?

                                                    <div className="p-4 text-justify" style={{ background: "#FFDE59", borderRadius: "15px" }}>
                                                        <div className="mb-4"><b>Entry Requirements</b></div>
                                                        <p>
                                                            Participating schools must submit the following:
                                                        </p>
                                                        <ul>
                                                            <li><b>1 School Report </b> (using SEAMEO SEPS template)</li>
                                                            <li><b>1 Video Clip (2-3 minutes)</b></li>
                                                            <li><b>Supporting documents/evidence/photos</b></li>
                                                        </ul>
                                                        <p><b>How to Submit:</b> Submission will be through <a href="https://docs.google.com/document/d/1D338jxk231uINDYZr2ImHEfu9YzZe5i4/edit?usp=sharing&ouid=107679553938785699259&rtpof=true&sd=true" target={"_blank"}><b>Google Form</b></a> (link and guidelines will be provided by SEAMEO SEPS) <br /><b>Deadline for Entry Submission:</b> Sunday 25 January 2026 </p>

                                                    </div>
                                                    : null}
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-center pb-md-3 text-start">
                                <div className="col-12 col-md-11 col-lg-9">
                                    <div className="topic mb-4 ">Prizes for Best-of-the-Best Schools</div>
                                    <div className="row justify-content-center align-items-center gap-4 text-center">
                                        <div className="col-4 col-md-2 col-lg-2">
                                            <img src={pitems1} className="w-100" alt="Indorama Ventures" />
                                            <span className="d-inline-block mt-3">Prize USD 500</span>
                                        </div>
                                        <div className="col-4 col-md-2 col-lg-2">

                                            <img src={pitems2} className="w-100" alt="Yunus Thailand" />
                                            <span className="d-inline-block mt-3">Prize USD 500</span>
                                        </div>
                                        <div className="col-4 col-md-2 col-lg-2">

                                            <img src={pitems3} className="w-100" alt="Yunus Thailand" />
                                            <span className="d-inline-block mt-3">Prize USD 500</span>
                                        </div>
                                        <div className="col-4 col-md-2 col-lg-2">

                                            <img src={pitems3} className="w-100" alt="Yunus Thailand" />
                                            <span className="d-inline-block mt-2">Prize USD 500</span>
                                        </div>
                                        <div className="col-4 col-md-2 col-lg-2">

                                            <img src={pitems3} className="w-100" alt="Yunus Thailand" />
                                            <span className="d-inline-block mt-3">Prize USD 500</span>
                                        </div>


                                    </div>
                                    <div className="text-start mt-4">
                                        <ul>
                                            <li><b>5 Best-of-the-Best Schools</b> - the school will receive the Prize of USD 500 and the school, school principal/director, teachers, students, and members of the school working committee will be given an e-Certificate of Recognition. </li>
                                            <li><b>10 Shortlisted Schools</b> - the school, school principal/director, teachers, students, and members of the school working committee will receive an e-Certificate of Recognition.</li>
                                            <li><b>Participating Schools </b> - the school, school principal/director and coordinating teachers will receive an e-Certificate of Participation.</li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-center pb-md-3 text-start">
                                <div className="col-12 col-md-11 col-lg-9">
                                    <div className="topic mb-4 ">About Waste Hero </div>
                                    <div className="row">
                                        <div className="col-12 col-md-9 col-lg-9">
                                            <div className="text-start">
                                                <ul>
                                                    <li>Waste Hero Education is a global initiative that provides free online teaching resources and customizable school lesson plans on recycling, zero-waste principles, and circular economy education.</li>
                                                    <li>Co-created by Indorama Ventures and Yunus Thailand, Waste Hero exemplifies circular economy best practices, supporting both education and community livelihoods. It creates shared value through education that extends beyond classrooms into the wider community.</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-3 col-lg-3">
                                            <img src={pcontent} className="w-100" alt="Yunus Thailand" />

                                        </div>
                                    </div>
                                    <div className="py-4"><img src={pfooter} className="w-100" alt="Yunus Thailand" /></div>
                                    <div className="text-start">
                                        <ul>
                                            <li>With resources available across multiple platforms, Waste Hero is now used by educators worldwide, reaching over 1 million educators and youth in 150 countries, enabling simple and scalable adoption by teachers globally.</li>
                                            <li>In 2023, an independent SROI assessment by a leading international sustainability consultancy confirmed the program’s strong impact: every 1 USD invested generates 4.49 USD in social value, driven by improved waste literacy, positive behavior change, and strengthened community recycling efforts in Indonesia and the Philippines.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-center pb-md-3 text-start">
                                <div className="col-12 col-md-11 col-lg-9">
                                    {dataOne.news && dataOne.news.length ?
                                        <div>
                                            <div className="topic mb-4 ">News</div>
                                            <div className="row">

                                                {dataOne.news.sort((a, b) => new Date(b.dateActive) - new Date(a.dateActive)).slice(0, dataLimit).map((val, index) => (
                                                    <div
                                                        className="col-12 col-md-4 col-lg-4"
                                                        key={index}
                                                    >
                                                        <Link
                                                            to={"/newsandgallery/news/" + val.newsId}
                                                            className="a-news pb-4 mb-4 mb-md-5"
                                                        >
                                                            <div className="row text-start">
                                                                <div className="col-12 col-md-12 col-lg-12">
                                                                    <div>
                                                                        <img
                                                                            src={
                                                                                process.env.REACT_APP_IMG_LINK +
                                                                                "/uploads/news/" +
                                                                                val.newsId +
                                                                                "/" +
                                                                                val.banner
                                                                            } alt=""
                                                                            className="w-100 rounded"
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-md-12 col-lg-12">
                                                                    <div className="font-14 mt-2">
                                                                        {moment(val.dateActive).format("D MMMM Y")}
                                                                    </div>

                                                                    <div className="news-topic mt-3 mt-md-0"
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: val.topic,
                                                                        }}
                                                                    />
                                                                    <div className="mt-4">
                                                                        <LinesEllipsis
                                                                            text={val.subTopic}
                                                                            maxLine="3"
                                                                            ellipsis="..."
                                                                            trimRight
                                                                            basedOn="letters"
                                                                        />
                                                                    </div>
                                                                    <div className="mt-3">
                                                                        <a style={{ color: "#e6c12f" }}>
                                                                            Read More
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="text-center mb-5">
                                                {dataLimit === 9 ?
                                                    <btn className="btn btn-watch-passtel font-16 px-5" onClick={e => setDataLimit(3)}>Less</btn>
                                                    :
                                                    <btn className="btn btn-watch-passtel font-16 px-5" onClick={e => setDataLimit(9)}>More</btn>
                                                }
                                            </div>
                                        </div>
                                        : null}
                                </div>
                            </div>
                            <div className="row justify-content-center pb-md-3 text-start">
                                <div className="col-12 col-md-11 col-lg-9">
                                    <div className="text-start topic mt-5 mb-3">Previous Activities</div>
                                    <div>
                                        <a href="https://seameoseps.org/activities/partnershipWasteHero" target={'_blank'} rel="noreferrer" className="btn btn-watch-passtel font-16 px-5 py-2">2024</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <Footer page="activities" sub="partnership" />
                </div>
            </div>


        </>


    );
};

export default Main;
